export const WALLET_DRAWER_TITLE_ID = 'certificates.wallet.drawerTitle';
export const WALLET_SECTION_TITLE_ID = 'certificates.wallet.sectionTitle';

export const DemoDomainName = 'https://demo-bookingflow.travcoding.com';
/** Account path segment placed before the app route (e.g. `/${DemoAccountName}/search`). */
export const DemoAccountName = 'demo-certificates';

export const CERTIFICATE_DEMO_CERTIFICATE_CODE_QUERY = 'certificateCode';
export const CERTIFICATE_DEMO_COVERAGE_AMOUNT_QUERY = 'coverageAmount';
export const CERTIFICATE_DEMO_NIGHTS_QUERY = 'nights';

/** Support phone shown on failed-instalment wallet banner only. */
export const WALLET_FAILED_INSTALMENT_SUPPORT_PHONE = '+1 789 098 788';
